import Link from "next/link";

/**
 * The chip renders a group's NAME and links by its SLUG, and reads nothing
 * else — so it is typed on exactly that. Both vocabularies satisfy it: the
 * legacy `Affiliation` (`group_id`/`name`/`slug`) and the v1 `GroupSummary`
 * (`id`/`name`/`slug`), which differ only in the field this component never
 * touches.
 */
interface AffiliationLike {
  name: string;
  slug: string;
}

// Small chip shown next to a username to indicate they administer a parent
// group (e.g. "Grønne Nabofællesskaber"). `inherited` marks the case where the
// person reaches the current sub-group through that parent rather than a direct
// membership.
export function AffiliationChip({
  affiliation,
  inherited = false,
  className = "",
}: {
  affiliation: AffiliationLike;
  inherited?: boolean;
  className?: string;
}) {
  return (
    <Link
      href={`/grupper/${affiliation.slug}`}
      title={
        inherited
          ? `Administrator i overgruppen ${affiliation.name}`
          : `Administrator i ${affiliation.name}`
      }
      className={`inline-flex items-center gap-1 rounded-full bg-emerald-100 dark:bg-emerald-900/50 px-1.5 py-0.5 text-[10px] font-medium leading-none text-emerald-700 dark:text-emerald-300 hover:bg-emerald-200 dark:hover:bg-emerald-900 transition-colors ${className}`}
    >
      <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
        <path d="M20 6 9 17l-5-5" />
      </svg>
      <span className="truncate max-w-[10rem]">{affiliation.name}</span>
    </Link>
  );
}
